import { useEffect, useState } from "react"

import { callApi } from "utils/ContentoApi"
import { PostBatchResponse } from "./types"
import { isGenerating } from "./utils"

const POLL_INTERVAL_MS = 1000

// Polls a post batch while `enabled` and returns its latest snapshot, stopping
// once the batch is no longer generating (done or failed). Used by cards that
// only render the inline GenerationLoader and need its progress data without
// owning a polling loop themselves.
export const usePostBatchProgress = (
  accountId: string,
  postBatchId: string | null | undefined,
  enabled: boolean,
): PostBatchResponse | null => {
  const [batch, setBatch] = useState<PostBatchResponse | null>(null)

  useEffect(() => {
    if (!enabled || !postBatchId) return

    let stopped = false
    let timeoutId: number | null = null

    const poll = async () => {
      try {
        const response: PostBatchResponse = await callApi(
          { method: "get", url: `content-factory/accounts/${accountId}/postBatches/${postBatchId}` },
          true,
          true,
        )
        if (stopped) return
        if (response) {
          setBatch(response)
          if (!isGenerating(response)) return
        }
      } catch {
        // Keep polling on transient errors.
      }
      if (!stopped) timeoutId = window.setTimeout(poll, POLL_INTERVAL_MS)
    }

    poll()

    return () => {
      stopped = true
      if (timeoutId) window.clearTimeout(timeoutId)
    }
  }, [accountId, postBatchId, enabled])

  return batch
}
